import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGame } from "../header/GameContext";
import { ANSWERS_DATA } from "./correctAnswerDatas";
import Parse from "parse";

const NO_MISSION_CODE = ["st1", "end11"]; //단서 증가 없이 페이지 이동만 하는 코드 (keywordInfo.answerData 확인)
const IS_QUIZ_CODE = ["loc06", "sbt07", "lck05", "clu06", "end11"]; //퀴즈가 있는 스테이지

function KeywordCheck({ onWrong, answerData }) {
  const {
    MISSION_TOTAL,
    clearedStages,
    increaseMissionOnce,
    time,
    playerKeyCode,
  } = useGame();

  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const KEYWORD_DATA = ANSWERS_DATA.keyword[0];
  const handleSubmit = async () => {
    const key = value.trim().toLowerCase(); //입력 키워드
    const keywordInfo = KEYWORD_DATA[key]; //입력 키워드와 매칭되는 데이터
    const isPlace = keywordInfo?.type === "place";

    if (!KEYWORD_DATA[key]) {
      onWrong();
      return;
    }

    if (isPlace) {
      // console.log("keywordInfo", keywordInfo.content);
      // return;
      navigate("/place", {
        state: {
          DateVal: keywordInfo.content,
          titImgClass: "placeTit",
        },
      });
    } else {
      if (keywordInfo) {
        const isMissionAllowed = !NO_MISSION_CODE.includes(key);
        const stageKey = keywordInfo.answerData;

        if (isMissionAllowed) {
          // 중복 키워드(입장 제한)
          // if (clearedStages.has(stageKey)) {
          //   alert("다른 코드를 찾아보자");
          //   return;
          // }

          increaseMissionOnce(stageKey);

          // 🔥 2. DB 저장
          try {
            console.log("🔥 저장 시작");

            if (!playerKeyCode) {
              console.warn("❌ keyCode 없음");
              return;
            }

            const Silence = Parse.Object.extend("silence1");
            const query = new Parse.Query(Silence);
            query.equalTo("keyCode", playerKeyCode);

            let obj = await query.first();

            // 🔥 최신 stage 반영 (중요)
            const updatedStages = new Set(clearedStages);
            updatedStages.add(stageKey);

            // if (!obj) {
            //   console.log("신규 생성");
            //   obj = new Silence();
            //   obj.set("keyCode", playerKeyCode);
            // }

            obj.set("stageKey", stageKey); // 마지막 진행
            // obj.set("stageKeys", [...updatedStages]); // 전체 진행
            // obj.set("remainTime", time); // 남은 시간
            obj.set("status", "ON");

            await obj.save();

            console.log("✅ 저장 완료", [...updatedStages], time);
          } catch (e) {
            console.error("❌ 저장 실패", e);
          }
        }

        if (IS_QUIZ_CODE.includes(key)) {
          // 단서 수집 미완료 시 최종 추론 접근 제한
          // if (key === "end11" && clearedStages.size + 1 < MISSION_TOTAL) {
          //   alert("다른 코드를 모두 진행해 주세요.");
          //   return;
          // }

          navigate("/quiz", {
            state: {
              answerData: stageKey,
              DateVal: keywordInfo.DateVal,
              titImgClass: keywordInfo.titImgclassName,
            },
          });
        } else {
          navigate("/info", {
            state: {
              DateVal: keywordInfo.DateVal,
              titImgClass: keywordInfo.titImgclassName,
            },
          });
        }
      }
    }
  };
  return (
    <div className="mt24 mb40">
      <input
        className="input01"
        placeholder="키워드를 입력하세요."
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <button
        className={`inputBtn01 mt16 ${value.trim().length > 0 ? "active" : ""}`}
        onClick={handleSubmit}
      >
        입력 완료
      </button>
    </div>
  );
}

export default KeywordCheck;
